import { render } from "./MultiUploadFormComponent.vue?vue&type=template&id=60fefc2c"
import script from "./MultiUploadFormComponent.vue?vue&type=script&lang=js"
export * from "./MultiUploadFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__